//#region import libraries
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';

// styling
import { Colors } from '_styles';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectPricingError, selectPricingStatus, selectDistribution, updatePricingInformation, selectCreateProduct, selectPricing } from '_redux/slices/marketplace/create-product';

// custom components
import { CustomSpinner, ErrorMessage, IconPageTitle } from '_atoms';

// icons
import { ImPriceTags } from "react-icons/im";

// tremor
import { Flex } from '@tremor/react';
//#endregion
const PricingForm = (props) => {
    const history = useHistory();
    //#region redux
    const dispatch = useDispatch();

    // redux distribution
    const distribution = useSelector(selectDistribution);
    const distributionError = useSelector(selectPricingError);
    //redux product
    const product = useSelector(selectCreateProduct);
    //redux pricing
    const pricingError = useSelector(selectPricingError);
    const pricingStatus = useSelector(selectPricingStatus);
    const pricing = useSelector(selectPricing)
    //#endregion

    //#region local states
    const [errors, setErrors] = useState({});
    const [showDeliveryPricing, setShowDeliveryPricing] = useState(false);
    const [pricingFieldsValues, setPricingFieldsValues] = useState({
        price: pricing?.price || '',
        deliveryPrice: pricing?.deliveryPrice || '',
        stock: pricing?.stock || '',
        listing: pricing?.listing || '',
    })
    const [priceBorder, setPriceBorder] = useState("grey");
    const [deliveryBorder, setDeliveryBorder] = useState("grey");
    const [stockBorder, setStockBorder] = useState("grey");
    const [listingBorder, setListingBorder] = useState("grey");
    //#endregion


    //#region functions
    const handleValidation = (fields) => {
        const tempErrors = {};
        const { price, deliveryPrice, listing, stock } = fields;
        if (!price) {
            tempErrors.price = 'Please enter a price for your product.'
            setPriceBorder("red")
        } else { setPriceBorder("green") }
        if (!deliveryPrice && showDeliveryPricing) {
            tempErrors.deliveryPrice = 'Please enter a delivery price for your product';
            setDeliveryBorder("red")
        } else { setDeliveryBorder("green") }
        if (!stock) {
            tempErrors.stock = 'Please enter the stock for your product.';
            setStockBorder("red")
        } else { setStockBorder("green") }
        if (!listing) {
            tempErrors.listing = 'Please choose if your product will be automatically available after submission or if you wish to manually release it after approval.';
            setListingBorder("red")
        } else { setListingBorder("green") }
        setErrors(tempErrors);
        return tempErrors
    }


    const handleSubmit = () => {
        const formErrors = handleValidation(pricingFieldsValues)
        if (!Object.keys(errors).length && !Object.keys(formErrors).length) {
            // submit object
            let params = { body: pricingFieldsValues, id: product.id };
            console.log('submitting pricing information', params)
            dispatch(updatePricingInformation(params))
        }
    }

    const handleBackButton = () => {
        props.back();
    }


    //change fields input, update state, call validation function
    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        setPricingFieldsValues((prevState) => {
            const updatedFields = { ...prevState, [name]: value };
            // Call validateFields with updated state
            handleValidation(updatedFields);

            return updatedFields;
        });
    }
    //#endregion

    //#region useEffect
    useEffect(() => {
        if (pricingStatus === "succeeded") {
            setPricingFieldsValues({
                price: '',
                deliveryPrice: '',
                stock: '',
                listing: '',
            })
            history.push('/marketplace')
        }
    }, [pricingStatus])

    // delivery pricing handler
    useEffect(() => {
        if (distribution && distribution.distributionOption) {
            if (distribution.distributionOption === 'DELIVERY-ONLY' || distribution.distributionOption === 'DELIVERY-COLLECTION') {
                setShowDeliveryPricing(true)
            }
            else {
                setShowDeliveryPricing(false)
            }
        }
    }, [distribution]);
    //#endregion

    return (
        <Row>

            <Flex>
                <div>

                    {/* Title */}
                    <IconPageTitle title={"Add Product Pricing Information"} subtitle={"Add the listing information required for your product"} icon={<ImPriceTags size={80} color={Colors.PRM_LIGHT_BLUE} />} back={handleBackButton} topText={"Step 3."} />

                </div>
                <div>
                    <Button variant={distributionError ? "danger" : "primary"} onClick={handleSubmit} loading={false} style={{ width: 200 }} className="mt-2">
                        {distributionError === 'loading' ? <CustomSpinner size={'sm'} style={{ color: 'white' }} /> : 'Add Pricing Information'}
                    </Button>
                </div>
            </Flex>

            <Container className='mt-3'>
                <hr style={{ borderColor: Colors.PRM_LIGHT_BLUE }} />
            </Container>

            {pricingError &&
                <Container>
                    <ErrorMessage
                        title={"Error Saving Pricing Information"}
                        error={pricingError}
                    />
                </Container>
            }

            {/* Price */}
            <Form.Group className='mt-4'>
                <Row>
                    <Col xs={6}>
                        <Form.Label style={{ color: priceBorder }}>Product Price</Form.Label>
                        <Form.Control onChange={handleChangeInput} name='price' type="number" placeholder="Enter the product price" value={pricingFieldsValues.price} style={{ borderColor: priceBorder }} />
                        {errors.price && (<p className="text-danger">{errors.price}</p>)}
                    </Col>
                    <Col xs={6}>
                        <Form.Label style={{ color: deliveryBorder }}>Delivery Price</Form.Label>
                        <Form.Control onChange={handleChangeInput} name='deliveryPrice' type="number" placeholder="Enter the product delivery price" value={pricingFieldsValues.deliveryPrice} style={{ borderColor: deliveryBorder }} />
                        {errors.deliveryPrice && (<p className="text-danger">{errors.deliveryPrice}</p>)}
                    </Col>
                </Row>
            </Form.Group>

            {/* Stock */}
            <Form.Group className='mt-4'>
                <Row>
                    <Col xs={6}>
                        <Form.Label style={{ color: stockBorder }}>Product Stock</Form.Label>
                        <Form.Control onChange={handleChangeInput} name='stock' type="number" placeholder="Enter the product stock" value={pricingFieldsValues.stock} style={{ borderColor: stockBorder }} />
                        {errors.stock && (<p className="text-danger">{errors.stock}</p>)}
                    </Col>
                </Row>
            </Form.Group>

            {/* Listing Options */}
            <Form.Group className='mt-4'>
                <Row>
                    <Col xs={6}>
                        <Form.Label style={{ color: listingBorder }}>Product Listing</Form.Label>
                        <p style={{ fontSize: 16, fontWeight: '400' }}>Please choose if your product will be automatically available after submission or if you wish to manually release it after approval.</p>
                        <div style={{ display: 'flex' }}>
                            <Form.Check type={"radio"} label={"Automatically Available"} value={"automatic"} name={"listing"} id={`listing-1`} checked={pricingFieldsValues.listing === "automatic"} onChange={handleChangeInput} />
                            <Form.Check type={"radio"} label={"Manually Release"} value={"manual"} name={"listing"} id={`listing-2`} checked={pricingFieldsValues.listing === "manual"} onChange={handleChangeInput} style={{ marginLeft: 16 }} />
                        </div>
                        {errors.listing && (<p className="text-danger">{errors.listing}</p>)}
                    </Col>
                </Row>
            </Form.Group>

        </Row>
    )
}

export default PricingForm;

